import { render, staticRenderFns } from "./UploadsPhotos.vue?vue&type=template&id=6e478025&scoped=true"
import script from "./UploadsPhotos.vue?vue&type=script&lang=js"
export * from "./UploadsPhotos.vue?vue&type=script&lang=js"
import style0 from "./UploadsPhotos.vue?vue&type=style&index=0&id=6e478025&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e478025",
  null
  
)

export default component.exports